const API_BASE_URL = 'https://api.gamerclub.mobi/admin/v1';

export const logVisit = async (refId = null, msisdn = null, baseQuery = null) => {
  try {
    // Allow callers to pass an explicit query string (e.g. the clean pid/clickid/ad_id
    // from the eTracker MSISDN callback). Falls back to the current URL's query string.
    let queryString = baseQuery !== null ? baseQuery : window.location.search;
    if (queryString && !queryString.startsWith('?')) {
      queryString = `?${queryString}`;
    }

    // Add refId to query string if provided
    if (refId) {
      const separator = queryString ? '&' : '?';
      queryString += `${separator}refId=${refId}`;
    }

    // Add msisdn to query string if provided (lets backend map AIS conversion by MSISDN)
    if (msisdn) {
      const separator = queryString ? '&' : '?';
      queryString += `${separator}msisdn=${msisdn}`;
    }

    const finalUrl = `${API_BASE_URL}/visitor-logs/log${queryString}`;
    console.log('Logging visit with refId:', refId, 'msisdn:', msisdn);
    console.log('Final URL:', finalUrl);

    const response = await fetch(finalUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.ok) {
      console.log('Visit logged successfully');
    } else {
      console.error('Visit log failed:', response.status);
    }
  } catch (error) {
    console.error('Error logging visit:', error);
  }
};
